module.exports = __webpack_public_path__ + "media/home1-center.36e3605a.mp4";